export const OTP_TYPE = {
  LOGIN: 0,
  POLICY: 1,
  APPLICATION_COMPLETE: 2,
  GUARANTOR_COMPLETE: 3
}
